import { createFileRoute, Navigate } from '@tanstack/react-router'

import { useIsAdmin } from '@/modules/account'
import {
  useFetchDirectoryAccounts,
  useFetchProject,
  useFetchTransactions,
} from '@/modules/projects'
import { Workbench } from '@/modules/projects/components/Workbench'
import { getProjectPath } from '@/utils'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/workbench',
)({
  component: ProjectWorkbench,
})

function ProjectWorkbench() {
  const { slug } = Route.useParams()
  const isAdmin = useIsAdmin()

  if (isAdmin === null) return null
  if (!isAdmin) return <Navigate to={getProjectPath({ slug })} />

  return <AdminWorkbench slug={slug} />
}

function AdminWorkbench({ slug }: { slug: string }) {
  useFetchProject(slug)
  // The coverage states the map paints are folded from the rows, so they have to be loaded here.
  useFetchTransactions(slug)
  useFetchDirectoryAccounts(slug)

  // The Workbench is its own full-screen screen: it covers the sidebar and the project tabs.
  return (
    <div className="fixed inset-0 z-50 bg-background">
      <Workbench />
    </div>
  )
}
